import { CmsContentState, NAME } from "./constants";

const getModel = (state): CmsContentState => state.get(NAME);

export const getRssItems = (state) => getModel(state).rss;
